import { render, staticRenderFns } from "./FeatureFlagsCopyStakeView.vue?vue&type=template&id=19867e8e&scoped=true&lang=pug"
import script from "./FeatureFlagsCopyStakeView.vue?vue&type=script&lang=ts"
export * from "./FeatureFlagsCopyStakeView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19867e8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VSkeletonLoader})
